export const getWeekdayName = dateString => {
    const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const date = new Date(dateString);
    const weekdayIndex = date.getDay();
    return weekDays[weekdayIndex];
};